import {createStyles} from '@material-ui/core/styles'
import {Colors} from 'components/common/useBaseStyle'

const PurchaseHistoryListStyle = () =>
  createStyles({
    pageContainer: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: 4,
      padding: '15px 14px 0 30px',
      backgroundColor: '#fff',
    },
    cardContainer: {
      minHeight: 700,
    },
    detailContainer: {
      marginTop: '20px',
      display: 'flex',
      gap: 30,
    },
    detailTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333',
    },
    detailTitleWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: 20,
      flex: 1,
    },
    card: {
      background: 'white',
      borderRadius: '15px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      padding: '25px',
      position: 'relative',
      overflow: 'hidden',
      transform: 'translateY(0)',
      transition: 'all 0.3s ease',

      '&::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: 'linear-gradient(90deg, #0cc7c7, #00a8a8)',
      },
    },
    productInfo: {
      flex: 1,
    },
    cardHeader: {
      display: 'flex',
      position: 'relative',
      padding: '20px 20px 0 20px',
    },

    cardNumber: {
      background: '#0cc7c7',
      color: 'white',
      width: '30px',
      height: '30px',
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 'bold',
      marginRight: '15px',
      fontSize: '14px',
    },

    customerInfo: {
      flex: 1,
    },

    cardTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333',
    },

    productSection: {
      padding: '10px 0',
      lineHeight: 1.6,
    },

    infoItem: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: '12px',
    },

    infoText: {
      color: '#333',
      fontSize: '15px',
    },

    table: {
      position: 'relative',
      minWidth: 880,
      color: 'red',
      marginTop: '15px',
      '& td': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: 2,
        paddingTop: 6,
        paddingBottom: 6,
        height: 43,
      },
      marginBottom: 20,
    },
    tableHeader: {
      height: 42,
      backgroundColor: Colors.tableHeaderBackground,
      verticalAlign: 'middle',
      borderRadius: 10,
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
      },
    },
    headerMax: {
      border: '1px solid rgba(224, 224, 224, 1)',
      padding: 8,
    },

    // Product Purchase History

    listCard: {
      display: 'flex',
      gap: '25px',
      flexDirection: 'column',
      marginBottom: '20px',
    },
    orderContainer: {
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(20px)',
      borderRadius: '24px',
      boxShadow: '0 25px 80px rgba(0, 0, 0, 0.15)',
      width: '100%',
      position: 'relative',
    },
    tableHeaderData: {
      height: 42,
      verticalAlign: 'middle',
      textAlign: 'start',
      '& th': {
        color: Colors.text.content,
        fontSize: '0.8125rem',
        lineHeight: '1rem',
        fontWeight: 'bold',
        border: 'none',
      },
    },
    rowDataTable: {
      borderTop: '1px solid rgba(224, 224, 224, 1)',
      padding: '12px 0',
      cursor: 'pointer',
    },
    orderHeader: {
      color: 'black',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    orderDate: {
      fontSize: '14px',
      opacity: '0.9',
      marginBottom: '8px',
      fontWeight: 500,
    },

    orderId: {
      fontSize: '13px',
      opacity: 0.8,
      background: 'rgba(255, 255, 255, 0.2)',
      borderRadius: '20px',
      display: 'inline-block',
      marginBottom: '5px',
    },
    orderTitle: {
      fontSize: '24px',
      fontWeight: 700,
      marginBottom: '4px',
    },
    orderContent: {
      padding: '20px',
    },

    orderProductInfo: {
      background: '#f8f9ff',
      borderRadius: '16px',
      padding: '24px',
      marginBottom: '24px',
      borderLeft: '4px solid #667eea',
    },

    orderProductDetails: {
      display: 'grid',
      gap: '20px',
      marginBottom: '20px',
    },

    detailItem: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },

    detailLabel: {
      fontSize: '12px',
      color: '#6b7280',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.5px',
    },

    detailValue: {
      fontSize: '16px',
      color: '#1f2937',
      fontWeight: 600,
    },
    diver: {
      height: '2.5px',
      background: '#e7e6eb',
    },
    priceAmount: {
      textAlign: 'right',
      fontSize: '24px',
      color: '#059669',
      fontWeight: 800,
      marginTop: '20px',
      marginBottom: '20px',
    },
    listBtn: {
      display: 'flex',
      justifyContent: 'center',
      gap: '20px',
    },
    cardStatus: {
      padding: '20px 40px',
      borderRadius: '12px',
      border: '1px solid #ccc',
      fontSize: '13px',
      backgroundColor: 'white',
      color: '#333',
      display: 'flex',
      flex: 1,
      gap: '12px',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 600,
      marginBottom: '20px',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
      width: '100%',
      position: 'relative',
    },
    orderName: {
      fontSize: '18px',
      fontWeight: 700,
      marginBottom: '4px',
    },
    listCardStatus: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: '10px',
      marginTop: '10px',
      padding: '12px 20px',
      backgroundColor: '#f9f9f9',
    },
  })

export default PurchaseHistoryListStyle
